import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card12.scss';

class Card12 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Atuação internacional é reforçada - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card12-home page-gradient page-gradient--yellow bg-gray" ref="card12-home">
          <section className="iniciativas-area card12-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">
                            Atuação internacional é reforçada
                            <br />
                            <span className="gri-text">
                              <b>GRI</b> 102-13
                            </span>
                          </h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-7">
                              <p>
                                Em 2020, a ANBIMA assumiu o comando de duas importantes entidades internacionais. Em
                                ambas, o representante é o nosso superintendente-geral, Zeca Doherty. Desde outubro, ele
                                é o presidente da{' '}
                                <a href="https://iifa.ca/" target="_blank">
                                  IIFA (Associação Internacional de Fundos de Investimento)
                                </a>
                                .
                              </p>
                              <p>
                                A entidade, sediada no Canadá, tem como membros 41 associações locais ou regionais de
                                fundos de investimento, de países dos cinco continentes, que somam US$ 54,9 trilhões de
                                ativos sob gestão. A presidência é alternada a cada dois anos, promovendo um rodízio
                                entre as regiões. Agora, na vez da América Latina, o convite foi feito à ANBIMA.
                              </p>
                              <p>
                                Em novembro, foi a vez da{' '}
                                <a href="http://www.fiafin.org/" target="_blank">
                                  Fiafin (Federação Iberoamericana de Fundos de Investimento)
                                </a>
                                , que Zeca assumiu como vice-presidente.
                              </p>
                              <p>
                                A entidade reúne 13 associações da Ibero-América (países com língua portuguesa ou
                                espanhola, principalmente da América Latina), que somam US$ 1,2 trilhão de ativos sob
                                gestão. A missão da Fiafin é integrar todas as associações de fundos da região para
                                promover crescimento, desenvolvimento e consolidação destes produtos como canalizadores
                                de poupança. Antes de ser vice-presidente, Zeca foi diretor da entidade por quatro anos.
                              </p>
                            </div>
                            <div className="col-5 img-center h-img">
                              <img src={images.iniciativas.card12.img2} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-12 box">
                  <h1 className="title">Confira os eventos que participamos em 2020:</h1>
                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card12.img1} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <h3>Junho</h3>
                      <span>
                        <b>Reunião do AMCC</b>
                      </span>
                      <p>
                        Realizado virtualmente, o encontro do AMCC (Comitê Consultivo de Membros Afiliados) da Iosco
                        (Organização Internacional de Comissões de Valores Mobiliários) foi pautado pela crise mundial
                        decorrente da pandemia, com destaque para as iniciativas adotadas para contê-la. Foi ressaltada
                        a solidez demonstrada pelas instituições e o bom funcionamento do mercado de capitais e da
                        indústria de fundos, que operaram adequadamente mesmo sob o estresse verificado nos primeiros
                        meses da pandemia.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card12.img1} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <h3>Setembro</h3>
                      <span>
                        <b>Reuniões Iarc e Cosra</b>
                      </span>
                      <p>
                        Encontro do Iarc (Comitê Regional Interamericano da Iosco), que ocorre junto com a reunião do
                        Cosra (Conselho de Reguladores das Américas), grupo do qual fazemos parte. Os efeitos da crise
                        sobre os mercados estiveram no centro das discussões.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-1 right">
                      <p>
                        <img src={images.iniciativas.card12.img1} className="card6-icons" />
                      </p>
                    </div>
                    <div className="col-11">
                      <h3>Novembro</h3>
                      <span>
                        <b>Conferência Anual da Iosco</b>
                      </span>
                      <p>
                        O evento, realizado virtualmente entre os dias 13 e 18 de novembro, discutiu as prioridades da
                        Iosco para 2021, com destaque para as reformas pós-pandemia. No foco estão a estabilidade
                        financeira e os riscos sistêmicos da intermediação financeira não bancária e a relação do
                        trabalho remoto com riscos de conduta, fraudes e golpes. Tais prioridades consolidam iniciativas
                        trabalhadas pela organização em 2020, como a sustentabilidade, a criação de um grupo para tratar
                        dos riscos sistêmicos e a conduta nos mercados de varejo na pandemia. Durante a conferência,
                        participamos também da reunião do AMCC (Comitê Consultivo de Membros Afiliados).
                      </p>
                      <span>
                        <b>13º Seminário de Treinamento do encontro anual Iosco e AMCC</b>
                      </span>
                      <p>
                        Realizado virtualmente em 4 de novembro, o treinamento é parte da agenda do encontro anual do
                        AMCC (Comitê Consultivo de Membros Afiliados). A pandemia e seus impactos sobre os mercados
                        foram tema de diversas palestras, incluindo a apresentação da ANBIMA, que abordou o tema
                        Supervisão remota: riscos potenciais e lições aprendidas na pandemia de Covid-19.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card12 };
